import React from 'react';

const IconCopy = () => (
  <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
    <rect height="10" rx="1" stroke="#111" strokeWidth="1.5" width="10" x="8" y="2" />
    <rect fill="white" height="10" rx="1" stroke="#111" strokeWidth="1.5" width="10" x="2" y="8" />
  </svg>
);

export default IconCopy;
